import React from "react";
import {
  ActivityIcon, AppstoreIcon, DatabaseIcon,
  PhoneCallIcon, TodoIcon, WorkflowIcon,
} from '@web/assets/icons';
import CallsContent from "@web/components/CallsContent";
import AppsContent from "@web/components/AppsContent";
import ContactDetailsWrapper from "@web/components/ContactActivityWrapper";
import ApplicationWorkflowCreate from "@web/components/ApplicationWorkflowCreate";
import CollectionManager from '@web/page/CollectionManager';
import TasksContent from '@web/components/TasksContent';
import AppStore from '@web/page/AppStore';

/** @typedef {String<('today'|'threads'|'calendars'|'activity'|'files'|'voice'|'website'|'payments'|'contacts'|'todos'|'trello'|'deliveries'|'workflow'|'chat'|'store'|'source'|'datasets'|'quote')>} dashboard.ServiceId */

/**
 * @typedef {Object} dashboard.SolutionsServiceConfig
 * @property {dashboard.ServiceId} key
 * @property {string} solutionId
 * @property {string} label
 * @property {string} path
 * @property {React.ReactNode} icon
 * @property {React.ReactNode} children
 * @property {React.ReactNode} search
 * @property {React.ReactNode} item
 * @property {string[]} sourceIds
 * @property {boolean} filter
 * @property {Object} chat
 * @property {string} chat.agentId
 * @property {string} chat.agentName
 * @property {function} chat.getCollectionPath
 */

// /** @typedef {Object<dashboard.ServiceId, dashboard.SolutionsServiceConfig>} dashboard.SolutionsServicesConfig */
const services = {
  // home: {
  //   key: "home",
  //   solutionId: 'activity',
  //   label: <span>Home</span>,
  //   path: "/home",
  //   icon: <HomeOutlined className="menu-icon"/>,
  //   closable: false,
  //   sourceIds: ["gmail", "outlook", "web"],
  //   children: ["feed", "assistant", "directory", "reminders"], // <CollectionFetch collectionId="activity" component={ContactActivityList} />,
  //   // view: ContactActivityWrapper,
  //   default: TodayContent,
  //   detail: ContactDetailsWrapper,
  //   extra: null, // ContactExtra,
  //   filter: {active: true, desktop: true, mobile: true},
  //   chat: {
  //     agentId: "ai-assistant",
  //     agentName: "Assistant",
  //     getAgentId: (app) => {
  //       return app?.agentId || "ai-assistant";
  //     },
  //     getActions: async (user, {contact}) => {
  //       const prompts = [];
  //       switch (true) {
  //         case contact?.email &&
  //         (!contact.email.toLowerCase().includes("noreply") &&
  //           !contact.email.toLowerCase().includes("no_reply") &&
  //           !contact.email.toLowerCase().includes("no-reply")) &&
  //         contact.email !== user?.email: {
  //           prompts.push({
  //             text: "Send email",
  //           });
  //           break;
  //         }
  //         default:
  //           break;
  //       }
  //       return prompts;
  //     }
  //   },
  // },
  // feed: {
  //   key: "feed",
  //   solutionId: 'activity',
  //   label: <span>Feed</span>,
  //   path: "/feed",
  //   icon: <HomeOutlined className="menu-icon"/>,
  //   children: <CollectionFetch collectionId="assistant" component={FeedList} />,
  //   view: FeedContent,
  //   sourceIds: [],
  //   filter: {desktop: true, active: true, mobile: true},
  //   chat: {
  //     agentId: "ai-line-assistant",
  //     agentName: "Assistant",
  //     overlayChat: true,
  //     getAgentId: (app) => {
  //       return app?.agentId || "ai-line-assistant";
  //     },
  //     // getCollectionPath: ({user, agentId, item}) => { // todo - this should probably move to line/assistant coll
  //     //   return item?.path ?
  //     //     `${item.path}/${agentId}` :
  //     //     `user/${user.uid}/managers/${agentId}/ai-workflow`;
  //     // },
  //     // getContext: (item) => {
  //     //   console.log("chat:getContext", item);
  //     //   return {
  //     //     path: item?.path,
  //     //     label: "Chat",
  //     //     // title: item?.file?.other?.displayName || item?.file?.originFilename,
  //     //   };
  //     // },
  //     getActions: async (user, {path}) => {
  //       return [{
  //         text: "Call me",
  //         agentId: "ai-line-assistant",
  //       }];
  //     }
  //   },
  // },
  // assistant: {
  //   key: "assistant",
  //   solutionId: 'activity',
  //   label: <span>Assistant</span>,
  //   path: "/assistant",
  //   icon: <MessageOutlined className="menu-icon"/>,
  //   children: <CollectionFetch collectionId="assistant" component={AssistantList} />,
  //   view: AssistantContent,
  //   sourceIds: [],
  //   filter: {desktop: true, active: true, mobile: true},
  //   chat: {
  //     agentId: "ai-line-assistant",
  //     agentName: "Assistant",
  //     overlayChat: true,
  //     getAgentId: (app) => {
  //       return app?.agentId || "ai-line-assistant";
  //     },
  //     // getCollectionPath: ({user, agentId, item}) => { // todo - this should probably move to line/assistant coll
  //     //   return item?.path ?
  //     //     `${item.path}/${agentId}` :
  //     //     `user/${user.uid}/managers/${agentId}/ai-workflow`;
  //     // },
  //     // getContext: (item) => {
  //     //   console.log("chat:getContext", item);
  //     //   return {
  //     //     path: item?.path,
  //     //     label: "Chat",
  //     //     // title: item?.file?.other?.displayName || item?.file?.originFilename,
  //     //   };
  //     // },
  //     getActions: async (user, {path}) => {
  //       return [{
  //         text: "Call me",
  //         agentId: "ai-line-assistant",
  //       }];
  //     }
  //   },
  // },
  tasks: {
    key: "tasks",
    solutionId: 'activity',
    label: <span>Tasks</span>,
    path: "/tasks",
    icon: <TodoIcon className="menu-icon"/>,
    children: null,
    application: TasksContent,
    sourceIds: [],
    filter: {desktop: true, active: true, mobile: true},
    // chat: {
    //   agentId: "ai-line-assistant",
    //   agentName: "Assistant",
    //   overlayChat: true,
    //   getAgentId: (app) => {
    //     return app?.agentId || "ai-line-assistant";
    //   },
    //   getActions: async (user, {path}) => {
    //     return [{
    //       text: "Call me",
    //       agentId: "ai-line-assistant",
    //     }];
    //   }
    // },
  },
  // apps: {
  //   key: "apps",
  //   solutionId: 'activity',
  //   label: <span>Apps</span>,
  //   path: "/apps",
  //   icon: <AppstoreIcon className="menu-icon"/>,
  //   children: null, //<CollectionFetch collectionId="apps" component={AppsList} />,
  //   view: AppsContent,
  //   detail: ContactDetailsWrapper,
  //   install: AppsContent,
  //   sourceIds: [],
  //   filter: {desktop: false, active: true, mobile: true},
  //   chat: {
  //     agentId: "ai-line-assistant",
  //     agentName: "Assistant",
  //     overlayChat: true,
  //     getAgentId: (app) => {
  //       // console.log("chat:getAgentId", app);
  //       return app?.agentId || "ai-line-assistant";
  //     },
  //     // getCollectionPath: ({user, agentId, item, app}) => { // todo - this should probably move to line/assistant coll
  //     //   if (app?.path) return `${app.path}/managers/${agentId}/ai-workflow`;
  //     //   return item?.path ?
  //     //     `${item.path}/managers/${agentId}/ai-workflow` :
  //     //     `user/${user.uid}/managers/${agentId}/ai-workflow`;
  //     // },
  //     // getContext: (item) => {
  //     //   console.log("chat:getContext", item);
  //     //   return {
  //     //     path: item?.path,
  //     //     label: "Chat",
  //     //     // title: item?.file?.other?.displayName || item?.file?.originFilename,
  //     //   };
  //     // },
  //     getActions: async (user, {path}) => {
  //       return [{
  //         text: "Help",
  //         agentId: "ai-line-apps-assistant",
  //       },{
  //         text: "Run this app",
  //         agentId: "ai-line-apps-assistant",
  //       }];
  //     }
  //   },
  // },
  // create: {
  //   key: "create",
  //   solutionId: 'activity',
  //   label: <span>Create</span>,
  //   path: "/apps/create",
  //   icon: <AppstoreIcon className="menu-icon"/>,
  //   children: null, //<CollectionFetch serviceId="apps" component={AppsList} />,
  //   default: CreateContent,
  //   application: CreateContent,
  //   // view: CreateContent,
  //   sourceIds: [],
  //   filter: {desktop: false, active: true, mobile: true},
  //   chat: {
  //     agentId: "ai-line-assistant",
  //     agentName: "Assistant",
  //     overlayChat: true,
  //     getAgentId: (app) => {
  //       console.log("chat:getAgentId", app);
  //       return app?.agentId || "ai-line-assistant";
  //     },
  //     // getCollectionPath: ({user, agentId, item, app}) => { // todo - this should probably move to line/assistant coll
  //     //   if (app?.path) return `${app.path}/managers/${agentId}/ai-workflow`;
  //     //   return item?.path ?
  //     //     `${item.path}/managers/${agentId}/ai-workflow` :
  //     //     `user/${user.uid}/managers/${agentId}/ai-workflow`;
  //     // },
  //     // getContext: (item) => {
  //     //   console.log("chat:getContext", item);
  //     //   return {
  //     //     path: item?.path,
  //     //     label: "Chat",
  //     //     // title: item?.file?.other?.displayName || item?.file?.originFilename,
  //     //   };
  //     // },
  //     getActions: async (user, {path}) => {
  //       return [{
  //         text: "Help",
  //         agentId: "ai-line-apps-assistant",
  //       },{
  //         text: "Run this app",
  //         agentId: "ai-line-apps-assistant",
  //       }];
  //     }
  //   },
  // },
  // app: {
  //   key: "app",
  //   solutionId: 'activity',
  //   label: <span>App</span>,
  //   path: "/apps/:appId",
  //   icon: <AppstoreIcon className="menu-icon"/>,
  //   children: null,
  //   install: AppContent,
  //   sourceIds: [],
  //   filter: {desktop: true, active: true, mobile: true},
  //   chat: {
  //     agentId: "ai-line-app-assistant",
  //     agentName: "Assistant",
  //     overlayChat: true,
  //     getAgentId: (app) => {
  //       // console.log("chat:getAgentId", app);
  //       return app?.agentId || "ai-line-app-assistant";
  //     },
  //     // getCollectionPath: ({user, agentId, item, app}) => { // todo - this should probably move to line/assistant coll
  //     //   if (app?.path) return `${app.path}/managers/${agentId}/ai-workflow`;
  //     //   return item?.path ?
  //     //     `${item.path}/managers/${agentId}/ai-workflow` :
  //     //     `user/${user.uid}/managers/${agentId}/ai-workflow`;
  //     // },
  //     // getContext: (item) => {
  //     //   console.log("chat:getContext", item);
  //     //   return {
  //     //     path: item?.path,
  //     //     label: "Chat",
  //     //     // title: item?.file?.other?.displayName || item?.file?.originFilename,
  //     //   };
  //     // },
  //     getActions: async (user, {path}) => {
  //       return [{
  //         text: "Help",
  //         agentId: "ai-line-apps-assistant",
  //       },{
  //         text: "Run this app",
  //         agentId: "ai-line-apps-assistant",
  //       }];
  //     }
  //   },
  // },
  // sandbox: {
  //   key: "sandbox",
  //   solutionId: 'activity',
  //   label: <span>Sandbox</span>,
  //   path: "/sandbox/:appId",
  //   icon: <AppstoreIcon className="menu-icon"/>,
  //   children: null, //<CollectionFetch serviceId="apps" component={AppsList} />,
  //   view: ApplicationWorkflowCreate,
  //   create: ApplicationWorkflowCreate,
  //   // install: AppContent,
  //   // detail: ContactDetailsWrapper,
  //   sourceIds: [],
  //   filter: {desktop: true, active: true, mobile: true},
  //   // chat: {
  //   //   agentId: "ai-line-app-assistant",
  //   //   agentName: "Assistant",
  //   //   overlayChat: true,
  //   //   getAgentId: (app) => {
  //   //     return app?.agentId || "ai-line-app-assistant";
  //   //   },
  //   //   // getCollectionPath: ({user, agentId, item, app}) => { // todo - this should probably move to line/assistant coll
  //   //   //   if (app?.path) return `${app.path}/managers/${agentId}/ai-workflow`;
  //   //   //   return item?.path ?
  //   //   //     `${item.path}/managers/${agentId}/ai-workflow` :
  //   //   //     `user/${user.uid}/managers/${agentId}/ai-workflow`;
  //   //   // },
  //   //   // getContext: (item) => {
  //   //   //   console.log("chat:getContext", item);
  //   //   //   return {
  //   //   //     path: item?.path,
  //   //   //     label: "Chat",
  //   //   //     // title: item?.file?.other?.displayName || item?.file?.originFilename,
  //   //   //   };
  //   //   // },
  //   //   getActions: async (user, {path}) => {
  //   //     return [{
  //   //       text: "Help",
  //   //       agentId: "ai-line-apps-assistant",
  //   //     },{
  //   //       text: "Run this app",
  //   //       agentId: "ai-line-apps-assistant",
  //   //     }];
  //   //   }
  //   // },
  // },
  workflows: {
    key: "workflows",
    solutionId: 'activity',
    label: <span>Workflows</span>,
    path: "/workflows/:workflowId",
    icon: <WorkflowIcon className="menu-icon"/>,
    children: null, //<CollectionFetch serviceId="apps" component={AppsList} />,
    view: ApplicationWorkflowCreate,
    create: ApplicationWorkflowCreate,
    // install: AppContent,
    // detail: ContactDetailsWrapper,
    sourceIds: [],
    filter: {desktop: true, active: true, mobile: true},
    // chat: {
    //   agentId: "ai-line-app-assistant",
    //   agentName: "Assistant",
    //   overlayChat: true,
    //   getAgentId: (app) => {
    //     return app?.agentId || "ai-line-app-assistant";
    //   },
    //   // getCollectionPath: ({user, agentId, item, app}) => { // todo - this should probably move to line/assistant coll
    //   //   if (app?.path) return `${app.path}/managers/${agentId}/ai-workflow`;
    //   //   return item?.path ?
    //   //     `${item.path}/managers/${agentId}/ai-workflow` :
    //   //     `user/${user.uid}/managers/${agentId}/ai-workflow`;
    //   // },
    //   // getContext: (item) => {
    //   //   console.log("chat:getContext", item);
    //   //   return {
    //   //     path: item?.path,
    //   //     label: "Chat",
    //   //     // title: item?.file?.other?.displayName || item?.file?.originFilename,
    //   //   };
    //   // },
    //   getActions: async (user, {path}) => {
    //     return [{
    //       text: "Help",
    //       agentId: "ai-line-apps-assistant",
    //     },{
    //       text: "Run this app",
    //       agentId: "ai-line-apps-assistant",
    //     }];
    //   }
    // },
  },
  "app-store": {
    key: "store",
    solutionId: 'activity',
    label: <span>Store</span>,
    path: "/apps/store",
    icon: <AppstoreIcon className="menu-icon"/>,
    children: null,
    // table: SharedCollection,
    application: AppsContent,
    detail: ContactDetailsWrapper,
    store: AppStore,
    // install: AppContent,
    sourceIds: [],
    filter: {desktop: false, active: true, mobile: true},
  },
  calls:  {
    key: "calls",
    solutionId: 'activity',
    label: <span>Calls</span>,
    path: "/calls",
    icon: <PhoneCallIcon className="menu-icon"/>,
    children: null, //<CollectionFetch serviceId="subscribed" component={SubsList} />,
    view: CallsContent,
    detail: ContactDetailsWrapper,
    sourceIds: [],
    filter: {desktop: true, active: true, mobile: true},
    // chat: {
    //   agentId: "ai-line-assistant",
    //   agentName: "Assistant",
    //   overlayChat: true,
    //   getAgentId: (app) => {
    //     return app?.agentId || "ai-line-assistant";
    //   },
    //   // getCollectionPath: ({user, agentId, item}) => { // todo - this should probably move to line/assistant coll
    //   //   return item?.path ? `${item.path}/${agentId}` : `user/${user.uid}/managers/${agentId}/ai-workflow`;
    //   // },
    //   // getContext: (item) => {
    //   //   console.log("chat:getContext", item);
    //   //   return {
    //   //     path: item?.path,
    //   //     label: "Chat",
    //   //     // title: item?.file?.other?.displayName || item?.file?.originFilename,
    //   //   };
    //   // },
    //   getActions: async (user, {path}) => {
    //     return [{
    //       text: "Call me",
    //       agentId: "ai-line-assistant",
    //     }];
    //   }
    // },
  },
  // contacts: {
  //   key: "contacts",
  //   solutionId: 'activity',
  //   label: <span>Contacts</span>,
  //   path: "/contacts",
  //   icon: <ContactsOutlinedIcon className="menu-icon"/>,
  //   children: <CollectionFetch serviceId="contacts" component={ContactsList} />,
  //   view: ContactsContent,
  //   detail: ContactDetailsWrapper,
  //   sourceIds: [],
  //   filter: {desktop: true, active: true, mobile: true},
  //   chat: {
  //     agentId: "ai-line-assistant",
  //     agentName: "Assistant",
  //     overlayChat: true,
  //     getAgentId: (app) => {
  //       return app?.agentId || "ai-line-assistant";
  //     },
  //     // getCollectionPath: ({user, agentId, item}) => { // todo - this should probably move to line/assistant coll
  //     //   return item?.path ? `${item.path}/${agentId}` : `user/${user.uid}/managers/${agentId}/ai-workflow`;
  //     // },
  //     // getContext: (item) => {
  //     //   console.log("chat:getContext", item);
  //     //   return {
  //     //     path: item?.path,
  //     //     label: "Chat",
  //     //     // title: item?.file?.other?.displayName || item?.file?.originFilename,
  //     //   };
  //     // },
  //     getActions: async (user, {path}) => {
  //       return [{
  //         text: "Call me",
  //         agentId: "ai-line-assistant",
  //       }];
  //     }
  //   },
  // },
  // links: {
  //   key: "links",
  //   solutionId: 'activity',
  //   label: <span>Links</span>,
  //   path: "/links",
  //   icon: <LinkOutlined className="menu-icon"/>,
  //   children: null, //<CollectionFetch serviceId="apps" component={AppsList} />,
  //   view: LinksContent,
  //   detail: ContactDetailsWrapper,
  //   sourceIds: [],
  //   filter: {desktop: true, active: true, mobile: true},
  //   chat: {
  //     agentId: "ai-line-assistant",
  //     agentName: "Assistant",
  //     overlayChat: true,
  //     getAgentId: (app) => {
  //       return app?.agentId || "ai-line-assistant";
  //     },
  //     // getCollectionPath: ({user, agentId, item}) => { // todo - this should probably move to line/assistant coll
  //     //   return item?.path ?
  //     //     `${item.path}/${agentId}` :
  //     //     `user/${user.uid}/managers/${agentId}/ai-workflow`;
  //     // },
  //     // getContext: (item) => {
  //     //   console.log("chat:getContext", item);
  //     //   return {
  //     //     path: item?.path,
  //     //     label: "Chat",
  //     //     // title: item?.file?.other?.displayName || item?.file?.originFilename,
  //     //   };
  //     // },
  //     getActions: async (user, {path}) => {
  //       return [{
  //         text: "Help",
  //         agentId: "ai-line-assistant",
  //       }];
  //     }
  //   },
  // },
  // lines: {
  //   key: "lines",
  //   solutionId: 'activity',
  //   label: <span>Lines</span>,
  //   path: "/lines",
  //   icon: <StarIcon className="menu-icon"/>,
  //   children: ["directory", "calls", "subscriptions", "subscribers"], // <CollectionFetch serviceId="subscribed" component={SubsList} />,
  //   view: TodayContent,
  //   // detail: LineDetail,
  //   sourceIds: [],
  //   filter: {desktop: true, active: true, mobile: true},
  //   chat: {
  //     agentId: "ai-line-assistant",
  //     agentName: "Assistant",
  //     overlayChat: true,
  //     getAgentId: (app) => {
  //       return app?.agentId || "ai-line-assistant";
  //     },
  //     getActions: async (user, {path}) => {
  //       return [{
  //         text: "Call me",
  //         agentId: "ai-line-assistant",
  //       }];
  //     }
  //   },
  // },
  // directory: {
  //   key: "directory",
  //   solutionId: 'activity',
  //   label: <span>Public Directory</span>,
  //   path: "/directory",
  //   icon: <StarIcon className="menu-icon"/>,
  //   children: <CollectionFetch collectionId="directory" component={LinesList} />,
  //   view: DirectoryContent,
  //   detail: LineDetail,
  //   sourceIds: [],
  //   filter: {desktop: true, active: true, mobile: true},
  //   chat: {
  //     agentId: "ai-line-assistant",
  //     agentName: "Assistant",
  //     overlayChat: true,
  //     getAgentId: (app) => {
  //       return app?.agentId || "ai-line-assistant";
  //     },
  //     getActions: async (user, {path}) => {
  //       return [{
  //         text: "Call me",
  //         agentId: "ai-line-assistant",
  //       }];
  //     }
  //   },
  // },
  // subscriptions: {
  //   key: "subscriptions",
  //   solutionId: 'activity',
  //   label: <span>Subscriptions</span>,
  //   path: "/subscriptions",
  //   icon: <AccountIcon className="menu-icon"/>,
  //   children: <CollectionFetch collectionId="subscriptions" component={SubsList} />,
  //   view: LinesContent,
  //   sourceIds: [],
  //   filter: {desktop: true, active: true, mobile: true},
  //   chat: {
  //     agentId: "ai-line-assistant",
  //     agentName: "Assistant",
  //     overlayChat: true,
  //     getAgentId: (app) => {
  //       return app?.agentId || "ai-line-assistant";
  //     },
  //     getActions: async (user, {path}) => {
  //       return [{
  //         text: "Call me",
  //         agentId: "ai-line-assistant",
  //       }];
  //     }
  //   },
  // },
  // subscribers: {
  //   key: "subscribers",
  //   solutionId: 'activity',
  //   label: <span>Subscribers</span>,
  //   path: "/subscribers",
  //   icon: <AccountIcon className="menu-icon"/>,
  //   children: <CollectionFetch collectionId="subscribers" component={SubsList} />,
  //   view: LinesContent,
  //   detail: ContactDetailsWrapper,
  //   sourceIds: [],
  //   filter: {desktop: true, active: true, mobile: true},
  //   chat: {
  //     agentId: "ai-line-assistant",
  //     agentName: "Assistant",
  //     overlayChat: true,
  //     getAgentId: (app) => {
  //       return app?.agentId || "ai-line-assistant";
  //     },
  //     getActions: async (user, {path}) => {
  //       return [{
  //         text: "Call me",
  //         agentId: "ai-line-assistant",
  //       }];
  //     }
  //   },
  // },
  // messenger: {
  //   key: "messenger",
  //   solutionId: 'activity',
  //   label: <span>Messenger</span>,
  //   path: "/messenger",
  //   icon: <FeatherIcon className="menu-icon"/>,
  //   children: null, // <ChatPage />,
  //   view: MessengerContent,
  //   detail: ContactDetailsWrapper,
  //   sourceIds: [],
  //   filter: {desktop: true, active: true, mobile: true},
  //   chat: {
  //     agentId: "ai-line-messenger",
  //     agentName: "Messenger",
  //     overlayChat: true,
  //     getAgentId: (app) => {
  //       return app?.agentId || "ai-line-messenger";
  //     },
  //     // getCollectionPath: ({user, messenger, claims}) => {
  //     //   const basePath = `user/${user.uid}/lines/messenger`;
  //     //   if (!messenger || messenger === claims?.data?._h) {
  //     //     return [basePath, "ai-workflow"].join("/");
  //     //   }
  //     //   return [basePath, "subscriber", messenger, "ai-workflow"].join("/");
  //     // },
  //     // getContext: (item) => {
  //     //   console.log("chat:getContext", item);
  //     //   return {
  //     //     path: item?.path,
  //     //     label: "Chat",
  //     //     // title: item?.file?.other?.displayName || item?.file?.originFilename,
  //     //   };
  //     // },
  //     getActions: async (user, {path}) => {
  //       return [{
  //         text: "latest topics",
  //         agentId: "ai-line-messenger",
  //       }];
  //     }
  //   },
  // },
  // activity: {
  //   key: "activity",
  //   solutionId: 'activity',
  //   label: <span>Activity</span>,
  //   path: "/activity",
  //   icon: <InboxIcon className="menu-icon"/>,
  //   closable: false,
  //   sourceIds: ["gmail", "outlook", "web"],
  //   children: <CollectionFetch collectionId="activity" component={ContactActivityList} />,
  //   home: null,
  //   // view: ContactActivityWrapper,
  //   view: ActivityContent,
  //   detail: ContactDetailsWrapper,
  //   extra: null, // ContactExtra,
  //   filter: {active: true, desktop: true, mobile: true},
  //   chat: {
  //     agentId: "ai-assistant",
  //     agentName: "Assistant",
  //     getAgentId: (app) => {
  //       return app?.agentId || "ai-assistant";
  //     },
  //     getActions: async (user, {contact}) => {
  //       const prompts = [];
  //       switch (true) {
  //         case contact?.email &&
  //         (!contact.email.toLowerCase().includes("noreply") &&
  //           !contact.email.toLowerCase().includes("no_reply") &&
  //           !contact.email.toLowerCase().includes("no-reply")) &&
  //         contact.email !== user?.email: {
  //           prompts.push({
  //             text: "Send email",
  //           });
  //           break;
  //         }
  //         default:
  //           break;
  //       }
  //       return prompts;
  //     }
  //   },
  // },
  timeline: {
    key: "timeline",
    solutionId: 'activity',
    label: <span>Timeline</span>,
    path: "/timeline",
    icon: <ActivityIcon className="menu-icon"/>,
    closable: false,
    sourceIds: ["gmail", "outlook", "web"],
    children: ["activity"], // <CollectionFetch collectionId="activity" component={ContactActivityList} />,
    // application: TodayContent,
    // default: TodayContent,
    detail: ContactDetailsWrapper,
    extra: null, // ContactExtra,
    filter: {active: true, desktop: true, mobile: true},
    chat: {
      agentId: "ai-assistant",
      agentName: "Assistant",
      getAgentId: (app) => {
        return app?.agentId || "ai-assistant";
      },
      getActions: async (user, {contact}) => {
        const prompts = [];
        switch (true) {
          case contact?.email &&
          (!contact.email.toLowerCase().includes("noreply") &&
            !contact.email.toLowerCase().includes("no_reply") &&
            !contact.email.toLowerCase().includes("no-reply")) &&
          contact.email !== user?.email: {
            prompts.push({
              text: "Send email",
            });
            break;
          }
          default:
            break;
        }
        return prompts;
      }
    },
  },
  // threads: {
  //   key: "threads",
  //   solutionId: "activity",
  //   label: <span>Email</span>,
  //   path: "/threads",
  //   icon: <EmailIconOutlined className="menu-icon" />,
  //   children: <CollectionFetch serviceId="threads" component={ThreadsList} />,
  //   view: ThreadsContent,
  //   detail: ContactDetailsWrapper,
  //   extra: null,
  //   sourceIds: ["gmail", "outlook"],
  //   filter: {active: true, desktop: true, mobile: true},
  //   overlayChat: true,
  //   chat: {
  //     agentId: "ai-assistant",
  //     agentName: "Assistant",
  //     getAgentId: (app) => {
  //       return app?.agentId || "ai-assistant";
  //     },
  //     getActions: async (user, {message}) => {
  //       const actions = [];
  //       if (!message) {
  //         return actions;
  //       }
  //       if (!message.from) {
  //         return actions;
  //       }
  //       switch (true) {
  //         case message.from?.email &&
  //         ((!message.from.email.toLowerCase().includes("noreply") &&
  //             !message.from.email.toLowerCase().includes("no_reply") &&
  //             !message.from.email.toLowerCase().includes("no-reply")) ||
  //           message.replyTo?.email) &&
  //         message.from.email !== user?.email: {
  //           actions.push({
  //             text: "Reply",
  //             agentId: "ai-email-assistant",
  //           });
  //           break;
  //         }
  //         default:
  //           break;
  //       }
  //       actions.push({
  //         text: "Forward",
  //         agentId: "ai-email-assistant",
  //       });
  //       actions.push({
  //         text: "summarize email",
  //         agentId: "ai-assistant",
  //       });
  //       return actions;
  //     },
  //   },
  // },
  // "x-profiler": {
  //   key: "x-profiler",
  //   solutionId: 'activity',
  //   label: <span>X Profiler</span>,
  //   path: "/x-profiler",
  //   icon: <AppstoreIcon className="menu-icon"/>,
  //   closable: false,
  //   sourceIds: ["twitter", "discord", "web"],
  //   children: ["collection", "apps/twitter-search-basic", "apps/twitter-profiler-basic", "apps/x-ranker-basic"], // <CollectionFetch serviceId="activity" component={ContactActivityList} />,
  //   view: CollectionManager,
  //   detail: <Card>Detail</Card>,
  //   extra: <Card>Extra</Card>,
  //   filter: {active: true, desktop: true, mobile: true},
  //   chat: {
  //     agentId: "ai-apps-manager",
  //     agentName: "Assistant",
  //     getAgentId: (app) => {
  //       return app?.agentId || "ai-assistant";
  //     },
  //     getActions: async (user, {contact}) => {
  //       const prompts = [];
  //       prompts.push({text: "What is this"})
  //       return prompts;
  //     }
  //   },
  // },
  collection: {
    key: "collection",
    solutionId: "activity",
    label: <span>Collection</span>,
    icon: <DatabaseIcon className="menu-icon" />,
    children: null, //<CollectionFetch collectionId="threads" component={ThreadsList} />,
    // view: ThreadsContent,
    view: CollectionManager,
    detail: ContactDetailsWrapper,
    extra: null,
    sourceIds: ["gmail", "outlook"],
    filter: {active: true, desktop: true, mobile: true},
    overlayChat: true,
    chat: {
      agentId: "ai-assistant",
      agentName: "Assistant",
      getAgentId: (app) => {
        return app?.agentId || "ai-assistant";
      },
      getActions: async (user, {message}) => {
        const actions = [];
        if (!message) {
          return actions;
        }
        if (!message.from) {
          return actions;
        }
        switch (true) {
          case message.from?.email &&
          ((!message.from.email.toLowerCase().includes("noreply") &&
              !message.from.email.toLowerCase().includes("no_reply") &&
              !message.from.email.toLowerCase().includes("no-reply")) ||
            message.replyTo?.email) &&
          message.from.email !== user?.email: {
            actions.push({
              text: "Reply",
              agentId: "ai-email-assistant",
            });
            break;
          }
          default:
            break;
        }
        actions.push({
          text: "Forward",
          agentId: "ai-email-assistant",
        });
        actions.push({
          text: "summarize email",
          agentId: "ai-assistant",
        });
        return actions;
      },
    },
  },
  // calendars: {
  //   key: "calendars",
  //   solutionId: 'activity',
  //   label: <IconTip key="calendar" title="calendar" placement="right">
  //     <div><CalendarIcon className="menu-icon"/></div>
  //   </IconTip>,
  //   path: "/calendar",
  //   icon: <CalendarIcon className="menu-icon"/>,
  //   children: <CalendarData key="calendar" component={CalendarEventsList}/>,
  //   view: CalendarEventDetailWrapper,
  //   sourceIds: ["gmail", "outlook", "calendar"],
  //   filter: {active: false},
  //   chat: {
  //     agentId: "ai-assistant",
  //     agentName: "Assistant",
  //     getCollectionPath: ({user, agentId, item}) =>
  //       item?.path ?
  //         `${item.path}/${agentId}` :
  //         `user/${user.uid}/managers/${agentId}/ai-workflow`,
  //     getContext: (item) => {
  //       console.log("calendars:getContext", item);
  //       return {
  //         path: item?.path,
  //         label: "Calendar",
  //         // title: item.data.name,
  //       };
  //     },
  //   }
  // },
  // files: {
  //   key: "files",
  //   solutionId: 'activity',
  //   label: <span>Files</span>,
  //   path: "/files",
  //   icon: <LayersIcon className="menu-icon"/>,
  //   sourceIds: ["drive", "files", "upload", "sheets"],
  //   children: <CollectionFetch serviceId="files" component={FileList} />,
  //   // view: FileDetailsWrapper,
  //   view: FilesContent,
  //   detail: ContactDetailsWrapper,
  //   extra: ContactExtra,
  //   filter: {active: true, desktop: true, mobile: true},
  //   chat: {
  //     agentId: "ai-assistant",
  //     agentName: "Assistant",
  //     getAgentId: (app) => {
  //       return app?.agentId || "ai-assistant";
  //     },
  //     getActions: async (user, {file}) => {
  //       if (!file) {
  //         return [];
  //       }
  //       if (file.alert) {
  //         return [];
  //       }
  //       const contentType = file.mimeType.split("/")[0].toLowerCase();
  //       const actions = [];
  //       switch (true) {
  //         case contentType === "audio": {
  //           if (!file.transcriptPath) {
  //             actions.push({
  //               text: "transcribe audio",
  //               agentId: "ai-audio-manager",
  //             });
  //           }
  //           if (file.transcriptPath && file.transcriptTs) { // transcript is available and ready
  //             actions.push({
  //               text: "search transcript",
  //               agentId: "ai-audio-manager",
  //             });
  //           }
  //           break;
  //         }
  //         case file.mimeType === "application/pdf":
  //           actions.push({
  //             text: "summarize document",
  //           });
  //           break;
  //         case file.mimeType === "application/json":
  //         case file.mimeType === "text/csv":
  //           if (!file.datasetPath) {
  //             actions.push({
  //               text: "Create dataset for analysis",
  //               agentId: "ai-analyst",
  //             });
  //           }
  //           break;
  //         default:
  //           break;
  //       }
  //       return actions;
  //     }
  //   },
  // },
  // payments: {
  //   key: "payments",
  //   solutionId: 'activity',
  //   label: <span>Payments</span>,
  //   path: "/payments",
  //   icon: <PaymentIcon className="menu-icon"/>,
  //   children: <CollectionFetch serviceId="payments" component={PaymentsList} />,
  //   sourceIds: ["stripe", "spreadsheet", "theScribe"],
  //   // view: PaymentDetail,
  //   view: PaymentsContent,
  //   detail: ContactDetailsWrapper,
  //   extra: null, //ContactExtra,
  //   filter: {active: true, desktop: true, mobile: true},
  //   chat: {
  //     agentId: "ai-assistant",
  //     agentName: "Assistant",
  //     getAgentId: (app) => {
  //       return app?.agentId || "ai-assistant";
  //     },
  //     getActions: async () => {
  //       const prompts = [];
  //       prompts.push({
  //         text: "About payments",
  //         agentId: "ai-assistant",
  //       });
  //       return prompts;
  //     }
  //   },
  // },
  // todos: {
  //   key: "todos",
  //   solutionId: 'activity',
  //   label: <IconTip key="todos" title="Todos" placement="right">
  //     <div><TodoIcon size={20}/></div>
  //   </IconTip>,
  //   path: "/todos",
  //   icon: <TodoIcon className="menu-icon" size={24}/>,
  //   children: <TodosData component={TodosList} />,
  //   sourceIds: ["trello", "asana", "gmail", "outlook", "voice"],
  //   view: TodoDetailWrapper,
  //   filter: {active: false},
  //   chat: {
  //     agentId: "ai-assistant",
  //     agentName: "Assistant",
  //     getCollectionPath: (user, agentId, item) =>
  //       item?.path ?
  //         `${item.path}/${agentId}` :
  //         `user/${user.uid}/managers/${agentId}/ai-workflow`,
  //     getContext: (item) => {
  //       console.log("todos:getContext", item);
  //       return {
  //         path: item?.path,
  //         label: "Todo",
  //         // title: item?.file?.other?.displayName || item?.file?.originFilename,
  //       };
  //     },
  //   },
  // },
  // trello: {
  //   key: "trello",
  //   solutionId: 'activity',
  //   label: <IconTip key="trello" title="Trell" placement="left">
  //     <div><TrelloIcon size={20}/></div>
  //   </IconTip>,
  //   path: "/trello",
  //   icon: <TrelloIcon className="menu-icon" size={24}/>,
  //   children: <TasksList list={[]} title="Projects" />,
  //   sourceIds: ["trello"],
  //   view: TrelloDetailWrapper,
  //   filter: {active: false},
  // },
  // deliveries: {
  //   key: "deliveries",
  //   solutionId: 'activity',
  //   label: <IconTip key="shipping" title="Shipping" placement="right">
  //     <span>Deliveries</span>
  //   </IconTip>,
  //   path: "/deliveries",
  //   icon: <TruckIcon className="menu-icon" />,
  //   children: <CollectionFetch serviceId="deliveries" component={DeliveriesList} />,
  //   sourceIds: ["shipping"],
  //   view: DeliveriesContent,
  //   detail: ContactDetailsWrapper,
  //   extra: null, //ContactExtra,
  //   filter: {active: true, desktop: true, mobile: true},
  //   chat: {
  //     agentId: "ai-assistant",
  //     agentName: "Assistant",
  //     getAgentId: (app) => {
  //       return app?.agentId || "ai-assistant";
  //     },
  //     getActions: async () => {
  //       const prompts = [];
  //       prompts.push({
  //         text: "today's deliveries",
  //         agentId: "ai-assistant",
  //       });
  //       return prompts;
  //     }
  //   },
  // },
  // analyst: {
  //   key: "analyst",
  //   solutionId: 'activity',
  //   label: <IconTip key="analyst" title="Analyst" placement="right">
  //     <span>Analyst</span>
  //   </IconTip>,
  //   path: "/analyst",
  //   icon: <LineChartIcon className="menu-icon"/>,
  //   // children: <Datasets />,
  //   children: ["datasets", "twitter-search-basic-data"],
  //   view: TodayContent,
  //   // view: Analyst,
  //   detail: Analyst,
  //   sourceIds: [],
  //   filter: {active: true, desktop: true, mobile: true},
  //   chat: {
  //     agentId: "ai-analyst",
  //     agentName: "Analyst",
  //     overlayChat: true,
  //     getAgentId: (app) => {
  //       return app?.agentId || "ai-analyst";
  //     },
  //     getActions: async (user, {data}) => {
  //       if (!data?.questions) return [];
  //       return data.questions.map(({question: text}) => {
  //         return {text};
  //       });
  //     }
  //   },
  // },
  // datasets: {
  //   key: "datasets",
  //   solutionId: 'activity',
  //   label: <IconTip key="analyst" title="Analyst" placement="right">
  //     <span>Datasets</span>
  //   </IconTip>,
  //   path: "/datasets",
  //   icon: <LineChartIcon className="menu-icon"/>,
  //   children: <Datasets />,
  //   // children: ["twitter-search-basic-data", "threads", "files", "contacts", "payments", "deliveries"],
  //   // view: TodayContent,
  //   view: Analyst,
  //   detail: null, //Analyst,
  //   sourceIds: [],
  //   filter: {active: true, desktop: true, mobile: true},
  //   chat: {
  //     agentId: "ai-analyst",
  //     agentName: "Analyst",
  //     overlayChat: true,
  //     getAgentId: (app) => {
  //       return app?.agentId || "ai-analyst";
  //     },
  //     getActions: async (user, {data}) => {
  //       if (!data?.questions) return [];
  //       return data.questions.map(({question: text}) => {
  //         return {text};
  //       });
  //     }
  //   },
  // },
  // forms: { // Will be handled under datasets and automations
  //   key: "forms",
  //   solutionId: 'workflows',
  //   label: <IconTip key="quotes" title="Forms" placement="right">
  //     <div><InboxIcon className="menu-icon"/></div>
  //   </IconTip>,
  //   path: "/forms",
  //   icon: <InboxIcon className="menu-icon"/>,
  //   children: null, // <QuotesList/>,
  //   sourceIds: [],
  //   view: null,
  //   filter: {active: false},
  //   chat: {
  //     agentId: "ai-manager",
  //     agentName: "Manager",
  //     getCollectionPath: ({user, agentId}) => `user/${user.uid}/managers/${agentId}/ai-workflow`,
  //     getContext: (item) => {
  //       console.log("quotes:getContext", item);
  //       return {
  //         path: item?.path,
  //         label: "Form",
  //       };
  //     },
  //   },
  // },
};

/** @typedef {('activity'|'analyst'|'product'|'workflows')} dashboard.SolutionId */

/**
 * @typedef {object} dashboard.SolutionConfig
 * @property {dashboard.SolutionId} key
 * @property {string} label
 * @property {string} agentName
 * @property {string} defaultService
 */

/** @typedef {Object<dashboard.SolutionId, dashboard.SolutionConfig>} dashboard.solutionsConfig */
const solutions = {
  activity: {
    key: "activity",
    label: "Activity",
    agentName: "Assistant",
    defaultService: "activity",
    chat: {
      getActions: async () => {
        const prompts = [];
        prompts.push({
          text: "summarize my latest activity",
        });
        return prompts;
      }
    },
  },
  analyst: {
    key: "analyst",
    label: "Analyst",
    agentName: "Analyst",
    defaultService: "datasets",
    chat: {
      getActions: async () => {
        const prompts = [];
        prompts.push({
          text: "About Analyst",
        });
        prompts.push({
          text: "Analyze dataset",
        });
        prompts.push({
          text: "Explore a website",
        });
        prompts.push({
          text: "search the internet",
        });
        return prompts;
      }
    },
  },
  lines: {
    key: "lines",
    label: "Lines",
    agentName: "Assistant",
    defaultService: "subscribed",
    path: "/lines",
    chat: {
      getActions: async (userRecord) => {
        // console.log("lines:get-actions:", userRecord);
        const prompts = [];
        prompts.push({text: "explore"});
        prompts.push({text: "call me"});
        prompts.push({text: "introductions", agentId: "ai-line-assistant"});
        return prompts;
      }
    },
  }
}

export const getSolutions = () => solutions;
export const getServices = () => services;

/**
 * @summary Chat App Agents
 * @description These agentIds are handled by chat apps and excluded from the primary stream (chat feedback)
 * @type {{emailWriter: {agentId: string}}}
 */
export const chatAppAgents = {
  emailWriter: {
    agentIds: ["ai-email-body-writer"], // ai-email-body-writer
  },
  progressViewer: {
    agentIds: ["ai-calls-manager"],
  }
  // userTaskProgress: {
  //   agentIds: ["ai-progress"],
  // },
}

export const chatAppAgentIds =
  Object.values(chatAppAgents)
  .map(({agentIds = []}) => agentIds)
  .flat();

// export const contentTypes = {
//   "video/3gpp": "unsupported",
//   "video/3gpp2": "unsupported",
//   "video/h261": "unsupported",
//   "video/h263": "unsupported",
//   "video/h264": "unsupported",
//   "video/jpeg": "video",
//   "video/jpm": "unsupported",
//   "video/mj2": "unsupported",
//   "video/mp4": "video",
//   "video/mpeg": "video",
//   "video/ogg": "video",
//   "video/quicktime": "video",
//   "video/webm": "video",
//   "video/x-matroska": "unsupported",
//   "video/x-ms-asf": "unsupported",
//   "video/x-msvideo": "unsupported",
//   "audio/aac": "audio",
//   "audio/flac": "audio",
//   "audio/midi": "unsupported",
//   "audio/mp4": "audio",
//   "audio/mpeg": "audio",
//   "audio/ogg": "audio",
//   "audio/wav": "audio",
//   "audio/webm": "audio",
//   "audio/x-m4a": "audio",
//   "audio/x-aac": "audio",
//   "audio/x-matroska": "unsupported",
//   "audio/x-ms-wma": "audio",
//   "audio/x-wav": "audio",
//   "image/bmp": "image",
//   "image/gif": "unsupported",
//   "image/jpeg": "image",
//   "image/png": "image",
//   "image/tiff": "image",
//   "image/webp": "image",
//   "application/msword": "document",
//   "application/pdf": "pdf",
//   "application/rtf": "document",
//   "application/vnd.google-apps.spreadsheet": "spreadsheet",
//   "application/vnd.ms-excel": "spreadsheet",
//   "application/vnd.ms-powerpoint": "document",
//   "application/vnd.oasis.opendocument.text": "document",
//   "application/vnd.openxmlformats-officedocument.presentationml.presentation": "document",
//   "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "spreadsheet",
//   "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "document",
//   "application/x-7z-compressed": "unsupported",
//   "application/x-rar-compressed": "unsupported",
//   "application/x-tar": "unsupported",
//   "application/zip": "unsupported",
//   "application/epub+zip": "unsupported",
//   "application/gzip": "unsupported",
//   "application/json": "dataset",
//   "application/ld+json": "dataset", // todo: add this to dataset handling
//   "application/jsonlines": "dataset", // todo: add this to dataset handling
//   "text/csv": "dataset",
//   "text/html": "document",
//   "text/plain": "document",
//   "text/rtf": "document",
//   "text/tab-separated-values": "dataset", // todo: add this to dataset handling
//   "text/xml": "document",
//   "text/calendar": "calendar", // .ics
//   "text/v-calendar": "calendar", // .vcs
//   "text/x-vcalendar": "calendar", // .vcs
//   "text/x-vcard": "contact", // .vcf
//   "text/vcard": "contact", // .vcf
// };
